<template>
  <AsyncPage
    :loader="useDashboardLoader"
    :page-component="Dashboard"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useDashboardLoader } from "./Dashboard.loader.ts";
import { dashboard as strings } from "./Dashboard.strings.ts";
import { AsyncPage } from "@saflib/vue/components";
import { useAsyncPageDocumentTitle } from "@saflib/vue";

useAsyncPageDocumentTitle(strings.documentTitle);

const Dashboard = defineAsyncComponent(
  () => import("./Dashboard.vue"),
);
</script>
